import React, { Component } from "react";
import AnnotationForm from "./AnnotationForm";
import Draggabilly from "draggabilly";

const draggies = [];
let draggableElems = null;
let draggie = null;

class AnnotationCanvas extends Component {
  constructor(props) {
    super(props);
    this.state = {
      admaterial: 0,
      annotationsSignals: [],
      color: "0xf1c40f",
      height: null,
      mounted: false,
      notesDeleted: [],
      placed: false,
      positionX: null,
      positionY: null,
      reviewed: false,
      translations: {},
      type: null,
      visible: false,
      width: null,
      zoom: 1
    };
  }

  componentDidUpdate() {
    //console.log('AnnotationCancas componentDidUpdate')
  }
  componentWillReceiveProps(nextProps) {
    const comp = this;
    setTimeout(function () {
      comp.setState({
        annotationFormVisible: false,
        width: comp.props.canvasWidth + "px",
        height: comp.props.canvasHeight + "px",
        type: comp.props.annotationType,
        admaterial: comp.props.admaterial,
        assetVisualId: comp.props.assetVisualId,
        zoom: comp.props.zoom,
        annotations: comp.props.annotations,
        translations: comp.props.translations
      });
      comp.loadAnnotations(
        comp.state.annotations,
        comp.state.admaterial,
        comp.state.assetVisualId
      );
    }, 100);
  }

  loadAnnotations = (annotations, admaterial, assetVisualId) => {
    this.setState({ annotationsSignals: [] });
    var annotationCanvas = document.getElementById("annotationCanvas");
    if (annotationCanvas)
      annotationCanvas.innerHTML = [this.state.annotationsSignals];
    if (annotations) {
      for (let i = 0; i < annotations.length; i++) {
        if (
          (!this.props.assetView &&
            admaterial &&
            annotations[i].parent.includes(admaterial)) ||
          (this.props.assetView &&
            annotations[i].parent.includes(assetVisualId))
        ) {
          for (let z = 0; z < annotations[i].signals.length; z++) {
            const positionX = annotations[i].signals[z].x;
            const positionY = annotations[i].signals[z].y;
            const annotationId = annotations[i].id;
            const color = annotations[i].color.replace("0x", "#");
            const text = annotations[i].text;
            const reviewed = annotations[i].marked;
            const creator = annotations[i].creator.name;
            const creatorId = annotations[i].creator.id;
            const time = annotations[i].time;
            const width = annotations[i].signals[z].width;
            const height = annotations[i].signals[z].height;
            const type = annotations[i].type;
            const page = annotations[i].page;
            this.placeAnnotation(
              width,
              height,
              positionY,
              positionX,
              type,
              color,
              annotationId,
              text,
              reviewed,
              creator,
              time,
              page,
              creatorId
            );
          }
        }
      }
    }

    const annotationForm = document.getElementById("annotationForm");
    if (annotationForm) {
      draggie = new Draggabilly(annotationForm, {
        containment: "#ReportPreviewContainer"
      });
      draggies.push(draggie);
    }

    draggableElems = document.querySelectorAll(".annotation-post");
    for (var i = 0; i < draggableElems.length; i++) {
      let currentNode = null;
      let draggableElem = draggableElems[i];
      if (draggableElem.getAttribute("id").includes("-"))
        draggie = new Draggabilly(draggableElem, {
          containment: "#annotationCanvas"
        });
      draggie.on("pointerDown", function (e, pointer) {
        currentNode = e.target.getAttribute("id");
      });
      draggie.on("dragStart", (e, pointer, moveVector) => {
        console.log(e);
        console.log(pointer);
        //currentNode = e.target.getAttribute("id");
      });
      draggie.on("dragMove", (e, pointer, moveVector) => {
        const node = document.getElementById(currentNode);
        if (node && node.classList.contains("annotation-post")) {
          const coordinates = this.getAnnotationCanvasPosition(
            e,
            "annotationCanvas"
          );
          console.log(coordinates);
          node.style.left =
            coordinates[0] -
            parseInt(draggie.element.style.width, 10) / 2 +
            "px";
          node.style.top =
            coordinates[1] -
            parseInt(draggie.element.style.height, 10) / 2 +
            "px";
        }
      });
      draggie.on("dragEnd", (e, pointer, moveVector) => {
        const node = document.getElementById(currentNode);
        if (node && node.classList.contains("annotation-post")) {
          const coordinates = this.getAnnotationCanvasPosition(
            e,
            "annotationCanvas"
          );
          console.log(coordinates);
          node.style.left =
            coordinates[0] -
            parseInt(draggie.element.style.width, 10) / 2 +
            "px";
          node.style.top =
            coordinates[1] -
            parseInt(draggie.element.style.height, 10) / 2 +
            "px";
        }
      });
      draggies.push(draggie);
    }
  };

  /*getMousePos = (canvas, evt) => {
      var rect = canvas.getBoundingClientRect();
      return {
        x: evt.clientX - rect.left,
        y: evt.clientY - rect.top
      };
  }*/
  handleFrameIn = (e, type) => {
    if (this.state.annotationFormVisible) return null;
    if (type === "FRAME" || type === "HIGHLIGHT") {
      console.log("MOUSE DOWN: type", type);
      this.setState({ mouseDown: true });
      const coordinates = this.getAnnotationCanvasPosition(
        e,
        "dummyFrameContainer"
      );
      const x = coordinates[0];
      const y = coordinates[1];
      this.setState({
        mousedownX: x,
        mousedownY: y,
        annotationFormVisible: false
      });
      e.stopPropagation();
    }
  };
  mouseMoveFunction = (e, type) => {
    if (this.state.mouseDown && (type === "FRAME" || type === "HIGHLIGHT")) {
      const coordinates = this.getAnnotationCanvasPosition(
        e,
        "dummyFrameContainer"
      );
      const x = coordinates[0];
      const y = coordinates[1];
      console.log("x: " + x + " y: " + y);
      this.drawFrame(x, y, type);
      return [x, y];
    }
  };
  drawFrame = (x, y, type) => {
    const { mousedownX, mousedownY } = this.state;
    const width = x - mousedownX;
    let height = null;
    if (type === "FRAME" || type === "HIGHLIGHT") height = y - mousedownY;
    const frame = {
      initX: mousedownX,
      initY: mousedownY,
      endX: x,
      endY: y,
      width: width,
      height: height,
      color: "#000"
    };
    document
      .getElementById("dummyFrame")
      .setAttribute(
        "style",
        "background:" +
        frame.color +
        ";top:" +
        frame.initY +
        "px;left:" +
        frame.initX +
        "px;width:" +
        frame.width +
        "px;height:" +
        frame.height +
        "px"
      );
  };
  handleFrameOut = (e, type) => {
    if (this.state.annotationFormVisible) return null;
    if (type === "FRAME" || type === "HIGHLIGHT") {
      const { mousedownX, mousedownY } = this.state;
      console.log("MOUSE UP: type", type);
      this.setState({ mouseDown: false });
      const coordinates = this.getAnnotationCanvasPosition(
        e,
        "dummyFrameContainer"
      );
      const x = coordinates[0];
      const y = coordinates[1];
      this.setState({ annotationFormVisible: true });
      const width = (x - mousedownX) * 1;
      let height = null;
      if (type === "HIGHLIGHT") height = (y - mousedownY) * 1;
      if (type === "FRAME") height = (y - mousedownY) * 1;
      this.setState({
        annotationHeight: parseInt(height, 10),
        annotationWidth: parseInt(width, 10),
        positionX: mousedownX,
        positionY: mousedownY
      });
      console.info(
        "Placing annotation at position x: " + mousedownX + " y:" + mousedownY
      );
      const randomId = parseInt(Math.random() * 100, 10);
      const annotationId = "-" + x + "" + y + "" + randomId;
      this.placeAnnotation(
        width,
        height,
        mousedownY,
        mousedownX,
        this.state.type,
        "#f1c40f",
        annotationId,
        null,
        null,
        null,
        null,
        this.props.pageCount
      );
      document
        .getElementById("saveAnnotationButton")
        .classList.remove("d-none");
      document
        .getElementById("colorAnnotationButton")
        .classList.remove("d-none");
      document.getElementById("assetNoteDropzone").classList.remove("d-none");
      setTimeout(function () {
        document.getElementById("annotationFormInput").focus();
        document
          .getElementById("annotationColorPicker")
          .classList.remove("visible");
        draggableElems = document.querySelectorAll(".annotation-post");
        for (var i = 0; i < draggableElems.length; i++) {
          let draggableElem = draggableElems[i];
          if (draggableElem.getAttribute("id").includes("-"))
            draggie = new Draggabilly(draggableElem, {
              containment: "#annotationCanvas"
            });
          draggies.push(draggie);
        }
      }, 250);
    }
  };
  getAnnotationCanvasPosition = (e, id) => {
    if (!id) id = "annotationCanvas";
    var annotationCanvas = document.getElementById(id);
    var rect = annotationCanvas.getBoundingClientRect();
    //FORMERLY WITHOUT DOCUMENT.BODY.STYLE.ZOOM
    var x = e.clientX / document.body.style.zoom;
    var y = e.clientY / document.body.style.zoom;
    x -= rect.left * 1;
    y -= rect.top * 1;
    x = parseInt(x / this.state.zoom, 10);
    y = parseInt(y / this.state.zoom, 10);
    console.log("Annotation position x:" + x + " y:" + y);
    this.setState({
      positionX: x,
      positionY: y,
      text: "",
      creator: null,
      time: null
    });
    return [x, y];
  };
  handleClick = e => {
    const annotationType = this.state.type;
    if (
      annotationType === "FRAME" ||
      annotationType === "HIGHLIGHT" ||
      this.state.annotationFormVisible
    ) {
      return null;
    }
    const coordinates = this.getAnnotationCanvasPosition(e, "annotationCanvas");
    const x = coordinates[0];
    const y = coordinates[1];
    this.setState({ annotationFormVisible: true });
    console.info("Placing annotation at position x:" + x + " y:" + y);
    const randomId = parseInt(Math.random() * 100, 10);
    const annotationId = "-" + x + "" + y + "" + randomId;

    this.setState({ annotationHeight: 24, annotationWidth: 24 });
    this.placeAnnotation(
      24,
      24,
      y,
      x,
      this.state.type,
      "#f1c40f",
      annotationId,
      null,
      null,
      null,
      null,
      this.props.pageCount
    );
    document.getElementById("saveAnnotationButton").classList.remove("d-none");
    document.getElementById("colorAnnotationButton").classList.remove("d-none");
    document.getElementById("assetNoteDropzone").classList.remove("d-none");
    setTimeout(function () {
      document.getElementById("annotationFormInput").focus();
      document
        .getElementById("annotationColorPicker")
        .classList.remove("visible");
      draggableElems = document.querySelectorAll(".annotation-post");
      for (var i = 0; i < draggableElems.length; i++) {
        let draggableElem = draggableElems[i];
        if (draggableElem.getAttribute("id").includes("-"))
          draggie = new Draggabilly(draggableElem, {
            containment: "#annotationCanvas"
          });
        draggies.push(draggie);
      }
    }, 250);
  };

  placeAnnotation = (
    width,
    height,
    top,
    left,
    type,
    color,
    annotationId,
    text,
    reviewed,
    creator,
    time,
    page,
    creatorId
  ) => {
    const annotationsSignals = this.state.annotationsSignals;
    const colorFormatted = color.replace("0x", "#").replace("0#", "#");
    let zoom = 1;
    if (type !== "STICKER") zoom = 1;
    else zoom = this.state.zoom;
    //zoom = this.state.zoom;
    const noteExist = annotationsSignals.filter(note =>
      note.props.id.includes(annotationId)
    );
    //console.log('noteExist' , noteExist)
    if (page === this.props.pageCount && noteExist.length === 0)
      annotationsSignals.push(
        <div
          onClick={this.handlePostClick}
          id={"annotationPost." + annotationId}
          key={Math.floor(900000 * Math.random()) + 100000}
          data-id={"annotation." + annotationId}
          className={"annotation-post annotation." + annotationId}
          data-type={type}
          data-top={top}
          data-left={left}
          data-text={text}
          data-color={colorFormatted}
          data-reviewed={reviewed}
          data-creator={creator}
          data-creatorid={creatorId}
          data-time={time}
          data-page={page}
          data-height={height}
          data-width={width}
          style={{
            width: width / zoom + "px",
            height: height / zoom + "px",
            top: top + "px",
            left: left + "px",
            backgroundColor: colorFormatted,
            border: "5px solid" + colorFormatted
          }}
        />
      );
    this.setState({
      annotationId: annotationId,
      annotationsSignals: annotationsSignals,
      closeButtonDisabled: true
    });
    //console.log('Annotation placed at: left ' + left + 'px');
    //console.log('Annotation placed at: top ' + top + 'px');
  };

  handlePostClick = e => {
    console.log(e.target);
    const element = e.target;
    let annotationId = element.getAttribute("data-id");
    annotationId = annotationId.replace("annotation.", "");
    let top = element.getAttribute("data-top");
    top = element.style.top;
    let left = element.getAttribute("data-left");
    left = element.style.left;
    let text = element.getAttribute("data-text");
    let color = element.getAttribute("data-color");
    let reviewed = element.getAttribute("data-reviewed");
    let creator = element.getAttribute("data-creator");
    let creatorId = element.getAttribute("data-creatorid");
    let time = element.getAttribute("data-time");
    let type = element.getAttribute("data-type");
    let width = element.getAttribute("data-width");
    let height = element.getAttribute("data-height");
    const annotationWidget = document.getElementById("widget." + annotationId);
    const annotationWidgets = document.getElementsByClassName(
      "annotation-widget"
    );
    if (annotationWidgets)
      for (let i = 0; i < annotationWidgets.length; i++) {
        /*annotationWidgets[i].classList.remove('widget-highlighted');*/
        annotationWidgets[i].style.boxShadow = "none";
      }
    /*if(annotationWidget) annotationWidget.classList.add('widget-highlighted')*/
    if (annotationWidget)
      annotationWidget.style.boxShadow = "inset 0 0 1px 1px " + color;
    top = parseInt(top, 10);
    left = parseInt(left, 10);
    this.setState({
      annotationFormVisible: true,
      positionY: top,
      positionX: left,
      annotationId: annotationId,
      text: text,
      color: color.replace("#", "0x"),
      reviewed: reviewed,
      creator: creator,
      creatorId: creatorId,
      time: time,
      type: type,
      closeButtonDisabled: false,
      annotationWidth: width,
      annotationHeight: height
    });
    console.log(this.props);
    if (
      !annotationId.includes("-") &&
      ((!this.props.canSaveownAnnotation && creatorId == this.props.userId) ||
        (!this.props.canSaveotherAnnotation && creatorId != this.props.userId))
    ) {
      document.getElementById("saveAnnotationButton").classList.add("d-none");
      document.getElementById("colorAnnotationButton").classList.add("d-none");
      document.getElementById("assetNoteDropzone").classList.add("d-none");
    } else {
      document
        .getElementById("saveAnnotationButton")
        .classList.remove("d-none");
      document
        .getElementById("colorAnnotationButton")
        .classList.remove("d-none");
      document.getElementById("assetNoteDropzone").classList.remove("d-none");
    }
    if (!annotationId.includes("-") && !this.props.canDeleteAnnotation) {
      document.getElementById("deleteAnnotationButton").classList.add("d-none");
    } else {
      document
        .getElementById("deleteAnnotationButton")
        .classList.remove("d-none");
    }
    setTimeout(function () {
      const annotationFormInput = document.getElementById(
        "annotationFormInput"
      );
      const annotationForm = document.getElementById("annotationForm");
      //document.getElementById('ReportPreviewContainer').scrollTop = annotationForm.style.top;
      document.getElementById("ReportPreviewContainer").scrollLeft = parseInt(
        annotationForm.style.left,
        10
      );
      annotationFormInput.focus();
    }, 250);
    document
      .getElementById("annotationColorPicker")
      .classList.remove("visible");

    e.stopPropagation();
  };
  annotationDeleted = annotationId => {
    console.log("Annotation deleted: " + annotationId);
    const annotations = this.state.annotations;
    for (let i = 0; i < annotations.length; i++) {
      if (annotations[i].id === parseInt(annotationId, 10)) {
        annotations.splice(i, 1);
      }
    }
    this.setState({ annotations: annotations });
  };
  render() {
    const { type } = this.state;
    return (
      <div>
        <div
          onClick={this.handleClick}
          type={type}
          style={{
            width: this.state.width ? this.state.width : "0",
            height: this.state.height ? this.state.height : "0",
            transform: "scale(" + this.state.zoom + ")"
          }}
          id="annotationCanvas"
          className="annotation-canvas"
        >
          {this.state.annotationsSignals}
        </div>
        {(type === "FRAME" || type === "HIGHLIGHT") && (
          <div
            id="dummyFrameContainer"
            style={{
              width: this.state.width ? this.state.width : "0",
              height: this.state.height ? this.state.height : "0",
              transform: "scale(" + this.state.zoom + ")"
            }}
            onMouseDown={e => this.handleFrameIn(e, type)}
            onMouseUp={e => this.handleFrameOut(e, type)}
            onMouseMove={e => this.mouseMoveFunction(e, type)}
            type={type}
          >
            <div id="dummyFrame" />
          </div>
        )}
        <AnnotationForm
          admaterial={this.state.admaterial}
          annotationDeleted={this.annotationDeleted}
          annotationId={this.state.annotationId}
          assetVisualId={this.props.assetVisualId}
          closeButtonDisabled={this.state.closeButtonDisabled}
          color={this.state.color}
          left={this.state.positionX}
          matspec={this.props.matspec}
          positionX={this.state.positionX}
          positionY={this.state.positionY}
          annotationWidth={this.state.annotationWidth}
          annotationHeight={this.state.annotationHeight}
          reviewed={this.state.reviewed}
          creator={this.state.creator}
          creatorId={this.state.creatorId}
          time={this.state.time}
          saveAnnotations={this.props.saveAnnotations}
          text={this.state.text}
          top={this.state.positionY}
          translations={this.state.translations}
          type={this.state.type}
          visible={this.state.annotationFormVisible}
          newAssetNote={this.props.newAssetNote}
          newAnnotationFlag={this.props.newAnnotationFlag}
          zoom={this.state.zoom}
          newAnnotations={this.props.newAnnotations}
        />
      </div>
    );
  }
}

export default AnnotationCanvas;



// WEBPACK FOOTER //
// ./src/components/AnnotationCanvas.js